import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { isApiConfigured } from '../../api/axiosClient';
import apiClient from '../../api/axiosClient';
import { CheckCircle, AlertCircle, Check, Key, Eye, EyeOff } from 'lucide-react';
import { ValidatedInput } from '../../components/ValidatedInput';
import { validators, formatters } from '../../utils/validators';
import { Turnstile } from '../../components/Turnstile';
import { useToast } from '../../components/Toast';
import { LoadingSpinner } from '../../components/LoadingSpinner';


const STEPS = ['Provider Info', 'Organization Info', 'Password Info'];

const RegisterPage = () => {
    const toast = useToast();
    const [step, setStep] = useState(0);
    const [error, setError] = useState('');
    const turnstileRef = useRef(null);//
    const [loading, setLoading] = useState(false);
    const [submitResult, setSubmitResult] = useState(null);
    const [submitErrorMsg, setSubmitErrorMsg] = useState('');
    const [turnstileToken, setTurnstileToken] = useState(null);
    const [agreed, setAgreed] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [form, setForm] = useState({
        firstName: '', lastName: '', title: '', email: '',
        taxId: '', organizationName: '', address: '', city: '', state: '', zipCode: '', phone: '',
        username: '', password: '', confirmPassword: '',
    });
    const navigate = useNavigate();

    const updateField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        setError('');
    };

    const [showPassword, setShowPassword] = useState(false);

    const generatePassword = () => {
        const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const lower = "abcdefghijklmnopqrstuvwxyz";
        const numbers = "0123456789";
        const special = "!@#$%^&*";

        const all = upper + lower + numbers + special;

        let password =
            upper[Math.floor(Math.random() * upper.length)] +
            lower[Math.floor(Math.random() * lower.length)] +
            numbers[Math.floor(Math.random() * numbers.length)] +
            special[Math.floor(Math.random() * special.length)];

        for (let i = password.length; i < 12; i++) {
            password += all[Math.floor(Math.random() * all.length)];
        }

        password = password
            .split("")
            .sort(() => Math.random() - 0.5)
            .join("");

        return password;
    };


    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    };

    const validateStep = () => {
        if (step === 0) {
            if (!form.firstName || !form.lastName || !form.title || !form.email) {
                setError('Please fill in all required fields.');
                return false;
            }
            if (validators.email(form.email)) {
                setError('Please enter a valid email address.');
                return false;
            }
        }
        if (step === 1) {
            if (!form.taxId || !form.organizationName || !form.address || !form.city || !form.state || !form.zipCode || !form.phone) {
                setError('Please fill in all required fields.');
                return false;
            }
            if (validators.phone(form.phone)) {
                setError('Please enter a valid phone number.');
                return false;
            }
        }
        if (step === 2) {
            if (!form.username || !form.password || !form.confirmPassword) {
                setError('Please fill in all required fields.');
                return false;
            }
            if (form.password !== form.confirmPassword) {
                setError('Passwords do not match.');
                return false;
            }
            if (validators.password(form.password)) {
                setError('Password must be at least 8 characters with upper, lower, and number.');
                return false;
            }
            if (!agreed) {
                setError('You must agree to the Terms of Service and Privacy Policy to continue.');
                return false;
            }
        }
        return true;
    };

    const handleNext = () => {
        if (!validateStep()) return;
        setError('');
        setStep(prev => prev + 1);
    };

    const handlePrevious = () => {
        setError('');
        setStep(prev => prev - 1);
    };


    //useEffect(() => {

    //    setPageLoading(true);
    //    if (turnstileToken != null) {
    //        setPageLoading(false);
    //    }

    //}, [turnstileToken]);

    useEffect(() => {

        if (
            turnstileToken &&
            typeof turnstileToken === 'string' &&
            turnstileToken.trim() !== ''
        ) {

            setPageLoading(false);

        } else {

            setPageLoading(true);
        }

    }, [turnstileToken]);

    const handleSubmit = async () => {
        if (!validateStep()) return;

        if (turnstileToken == null || turnstileToken == "") {
            location.reload();
            return;
        }
        setLoading(true);
        setError('');
        try {
            if (isApiConfigured()) {
                const { confirmPassword, ...payload } = form;
                
                //await apiClient.post('/auth/register', { ...payload, turnstileToken });
                var res = await apiClient.post('/api/provider/auth/register', {
                    firstName: payload.firstName,
                    lastName: payload.lastName,
                    title: payload.title,
                    email: payload.email,
                    taxId: payload.taxId.replace(/-/g, ''),
                    orgName: payload.organizationName,
                    orgPhone: payload.phone.replace(/\D/g, ""), 
                    address: payload.address,
                    city: payload.city,
                    state: payload.state,
                    zipCode: payload.zipCode,
                    phone: payload.phone.replace(/\D/g, ""),
                    password: payload.password,
                    username: payload.username,
                    userType: "Provider",
                    registerfor: "Provider",
                    userRole: "Provider Admin",
                    turnstileToken: turnstileToken
                });

             

                if (!res.data.Success)
                {
                    // clear old token
                     setTurnstileToken(null);

                    // generate fresh token
                    turnstileRef.current?.reset();
                    
                    setSubmitResult('error');
                    setSubmitErrorMsg(res.data.Message);

                    
                }
                else
                {
                    //alert("REG DONE");
                  //  toast.error(res.data.Message);
                    setSubmitResult('success');
                }

            } else {
                await new Promise(resolve => setTimeout(resolve, 1200));
            }
            
        } catch (err) {
            setSubmitErrorMsg(err.response?.data?.message || 'Registration failed. Please try again.');
            setSubmitResult('error');

            // clear old token
            setTurnstileToken(null);

            // generate fresh token
            turnstileRef.current?.reset();
        } finally {
            setLoading(false);
        }
    };

    const handleStepClick = (index) => {
        if (index < step) {
            setError('');
            setStep(index);
        }
    };

    const btnPrimary = {
        background: 'linear-gradient(135deg, #0D9488, #0F766E)',
        color: '#fff',
        border: 'none',
        borderRadius: 12,
        padding: '12px 28px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
        boxShadow: '0 6px 16px rgba(13,148,136,0.3)',
        transition: 'all 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    };

    const btnOutline = {
        background: 'transparent',
        color: '#0F766E',
        border: '1.5px solid #0F766E',
        borderRadius: 12,
        padding: '12px 28px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
        transition: 'all 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    };

    /* ── Success Screen ────────────────────────────────────────────── */
    if (submitResult === 'success') {
        return (
            <div className="auth-layout">
                <div style={{
                    background: '#fff', borderRadius: 20, padding: '60px 40px',
                    width: '100%', maxWidth: 480, textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)', zIndex: 1,
                    animation: 'slideUp 0.45s cubic-bezier(0.4,0,0.2,1)',
                }}>
                    <div style={{
                        width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px',
                        background: 'linear-gradient(135deg, #059669, #10B981)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <CheckCircle size={40} color="#fff" strokeWidth={2} />
                    </div>
                    <div style={{ fontSize: 24, fontWeight: 800, color: '#1A1D21', marginBottom: 8 }}>
                        Registration Successful!
                    </div>
                    <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 8 }}>
                        Your provider account has been created for <strong>{form.firstName} {form.lastName}</strong>.
                    </div>
                    <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6, marginBottom: 28 }}>
                        {/*You can now sign in with your username <strong>{form.username}</strong> and the password you created.*/}
                        Your account is currently pending approval by a Central Health Super Administrator. Once your account has been approved, you will receive a confirmation email at your registered email address <strong>{form.email}</strong>. You will then be able to sign in using your username <strong>{form.username}</strong> or email address <strong>{form.email}</strong> and password.
                    </div>
                    <div
                        onClick={() => navigate('/login')}
                        style={{
                            width: '100%', height: 52, borderRadius: 14, cursor: 'pointer',
                            background: 'linear-gradient(135deg, #0D9488, #0F766E)',
                            boxShadow: '0 6px 16px rgba(13,148,136,0.3)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >
                        <span style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>Go to Login</span>
                    </div>
                </div>
                <div className="auth-footer-links">
                    <a href="#terms">Terms of Service</a>
                    <a href="#privacy">Privacy Policy</a>
                    <a href="#contact">Contact</a>
                </div>
            </div>
        );
    }

    /* ── Error Screen ─────────────────────────────────────────────── */
    if (submitResult === 'error') {
        return (
            <>
                <div className="auth-layout">
                    {pageLoading && (
                        <div style={styles.overlay}>
                            <LoadingSpinner message="Please wait..." fullPage="true" />
                        </div>
                    )}
                <div style={{
                    background: '#fff', borderRadius: 20, padding: '60px 40px',
                    width: '100%', maxWidth: 480, textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)', zIndex: 1,
                    animation: 'slideUp 0.45s cubic-bezier(0.4,0,0.2,1)',
                }}>
                    <div style={{
                        width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px',
                        background: 'linear-gradient(135deg, #DC2626, #EF4444)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <AlertCircle size={40} color="#fff" strokeWidth={2} />
                    </div>
                    <div style={{ fontSize: 24, fontWeight: 800, color: '#1A1D21', marginBottom: 8 }}>
                        Registration Failed
                    </div>
                    <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 16 }}>
                        We were unable to create your account. Please try again.
                    </div>
                    <div style={{
                        padding: 14, borderRadius: 10, background: '#FEE2E2',
                        border: '1px solid rgba(239,68,68,0.2)', fontSize: 13,
                        color: '#991B1B', textAlign: 'left', marginBottom: 28, lineHeight: 1.5,
                    }}>
                        <strong>Error:</strong> {submitErrorMsg}
                    </div>
                    <div style={{ display: 'flex', gap: 12 }}>
                        <div
                            onClick={() => { setSubmitResult(null); setSubmitErrorMsg(''); }}
                            style={{
                                flex: 1, height: 48, borderRadius: 12, cursor: 'pointer',
                                border: '1.5px solid #E8ECF0', background: '#fff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>Back to Form</span>
                        </div>
                        <div
                            onClick={() => { setSubmitResult(null); setSubmitErrorMsg(''); handleSubmit(); }}
                            style={{
                                flex: 1, height: 48, borderRadius: 12, cursor: 'pointer',
                                background: 'linear-gradient(135deg, #0D9488, #0F766E)',
                                boxShadow: '0 4px 12px rgba(13,148,136,0.3)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>Retry</span>
                        </div>
                    </div>
                </div>
                </div>
                <Turnstile onVerify={setTurnstileToken} ref={turnstileRef} />
            </>
        );

        
    }

    return (
        <div className="auth-layout">
            <style>{`
        .reg-card {
          background: #fff;
          border-radius: 20px;
          width: 100%;
          max-width: 980px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.05);
          z-index: 1;
          display: flex;
          overflow: hidden;
          animation: slideUp 0.45s cubic-bezier(0.4, 0, 0.2, 1);
          min-height: 600px;
        }
        .reg-sidebar {
          width: 36%;
          min-width: 220px;
          background: linear-gradient(180deg, #0F766E, #134E4A);
          border-radius: 20px 0 0 20px;
          padding: 40px 28px;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          position: relative;
          overflow: hidden;
        }
        .reg-sidebar::before {
          content: '';
          position: absolute; top: -40px; right: -40px;
          width: 160px; height: 160px; border-radius: 50%;
          background: rgba(255,255,255,0.04); pointer-events: none;
        }
        .reg-sidebar::after {
          content: '';
          position: absolute; bottom: -60px; left: -60px;
          width: 200px; height: 200px; border-radius: 50%;
          background: rgba(45,212,191,0.06); pointer-events: none;
        }
        .reg-form-area {
          flex: 1;
          padding: 40px 40px;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }
        .reg-field-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0 16px;
        }
        .practice-note {
          margin-top: auto;
          padding: 16px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(45,212,191,0.2);
          border-radius: 12px;
          backdrop-filter: blur(8px);
          position: relative;
          z-index: 1;
        }
        @media (max-width: 768px) {
          .reg-card {
            flex-direction: column;
            max-width: 520px;
          }
          .reg-sidebar {
            width: 100%;
            min-width: unset;
            border-radius: 20px 20px 0 0;
            padding: 24px 20px;
          }
          .reg-form-area {
            padding: 24px 20px;
          }
          .reg-field-grid {
            grid-template-columns: 1fr;
          }
          .practice-note {
            display: none;
          }
        }
      `}</style>

            <div className="reg-card">
                {/* Left Sidebar */}
                <div className="reg-sidebar">
                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <div style={{ fontSize: 24, fontWeight: 800, color: '#fff', marginBottom: 8, letterSpacing: '-0.5px' }}>
                            Create Account
                        </div>
                        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginBottom: 36, lineHeight: 1.5 }}>
                            Complete the steps below to register your provider account.
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            {STEPS.map((label, i) => (
                                <React.Fragment key={i}>
                                    <div
                                        onClick={() => handleStepClick(i)}
                                        style={{
                                            padding: '14px 18px',
                                            borderRadius: 12,
                                            background: step === i ? 'rgba(45, 212, 191, 0.22)' : 'transparent',
                                            color: '#fff',
                                            opacity: step === i ? 1 : 0.6,
                                            fontSize: 14,
                                            fontWeight: step === i ? 700 : 500,
                                            cursor: i < step ? 'pointer' : 'default',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 12,
                                        }}
                                    >
                                        <div style={{
                                            width: 28,
                                            height: 28,
                                            borderRadius: 8,
                                            background: step === i ? 'rgba(45, 212, 191, 0.35)' : 'rgba(255,255,255,0.1)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 13,
                                            fontWeight: 700,
                                            flexShrink: 0,
                                        }}>
                                            {i < step ? <Check size={14} strokeWidth={3} /> : i + 1}
                                        </div>
                                        {label}
                                    </div>
                                    {i < STEPS.length - 1 && (
                                        <div style={{
                                            height: 1,
                                            background: 'rgba(255,255,255,0.12)',
                                            margin: '4px 18px',
                                        }} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    {/* Practice Note */}
                    <div className="practice-note">
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#5EEAD4', marginBottom: 6 }}>
                            Practice Note:
                        </div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>
                            Practice administrators MUST be the user to submit the registration request. All additional user accounts will be created and managed by the approved Practice Administrator.
                        </div>
                    </div>
                </div>

                {/* Right Form Area */}
                <div className="reg-form-area">
                    {error && (
                        <div className="error-text" style={{ marginBottom: 20 }}>
                            {error}
                        </div>
                    )}

                    {step === 0 && (
                        <>
                            <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-primary)', margin: '0 0 24px 0', letterSpacing: '-0.3px' }}>
                                Provider Information
                            </h2>
                            <div className="reg-field-grid">
                                <ValidatedInput
                                    label="First Name"
                                    required
                                    value={form.firstName}
                                    onChange={(v) => updateField('firstName', v)}
                                    validate={(v) => validators.required(v, 'First Name') || validators.alpha(v)}
                                />
                                <ValidatedInput
                                    label="Last Name"
                                    required
                                    value={form.lastName}
                                    onChange={(v) => updateField('lastName', v)}
                                    validate={(v) => validators.required(v, 'Last Name') || validators.alpha(v)}
                                />
                            </div>
                            <ValidatedInput
                                label="Title"
                                required
                                value={form.title}
                                onChange={(v) => updateField('title', v)}
                                validate={(v) => validators.required(v, 'Title')}
                                placeholder="e.g. MD, RN, NP"
                            />
                            <ValidatedInput
                                label="Email"
                                required
                                type="email"
                                value={form.email}
                                onChange={(v) => updateField('email', v)}
                                validate={(v) => validators.required(v, 'Email') || validators.email(v)}
                                placeholder="your.email@example.com"
                            />
                        </>
                    )}

                    {step === 1 && (
                        <>
                            <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-primary)', margin: '0 0 24px 0', letterSpacing: '-0.3px' }}>
                                Organization Information
                            </h2>
                            <div className="reg-field-grid">
                                <ValidatedInput
                                    label="Primary Tax ID"
                                    required
                                    value={form.taxId}
                                    onChange={(v) => updateField('taxId', v)}
                                    validate={(v) => validators.required(v, 'Tax ID') || validators.taxId(v)}
                                    format={formatters.taxId}
                                    placeholder="XX-XXXXXXX"
                                    helpText="Tax ID format"
                                />
                                <ValidatedInput
                                    label="Organization Name"
                                    required
                                    value={form.organizationName}
                                    onChange={(v) => updateField('organizationName', v)}
                                    validate={(v) => validators.required(v, 'Organization Name')}
                                />
                            </div>
                            <ValidatedInput
                                label="Address"
                                required
                                value={form.address}
                                onChange={(v) => updateField('address', v)}
                                validate={(v) => validators.required(v, 'Address')}
                                placeholder="123 Main Street"
                            />
                            <div className="reg-field-grid">
                                <ValidatedInput
                                    label="City"
                                    required
                                    value={form.city}
                                    onChange={(v) => updateField('city', v)}
                                    validate={(v) => validators.required(v, 'City') || validators.alpha(v)}
                                />
                                <ValidatedInput
                                    label="State"
                                    required
                                    value={form.state}
                                    onChange={(v) => updateField('state', v)}
                                    validate={(v) => validators.required(v, 'State') || validators.state(v)}
                                    format={formatters.state}
                                    placeholder="TX"
                                    maxLength={2}
                                />
                            </div>
                            <div className="reg-field-grid">
                                <ValidatedInput
                                    label="Zip Code"
                                    required
                                    value={form.zipCode}
                                    onChange={(v) => updateField('zipCode', v)}
                                    validate={(v) => validators.required(v, 'Zip') || validators.zip(v)}
                                    format={formatters.zip}
                                    placeholder="78702"
                                />
                                <ValidatedInput
                                    label="Phone Number"
                                    required
                                    type="tel"
                                    value={form.phone}
                                    onChange={(v) => updateField('phone', v)}
                                    validate={(v) => validators.required(v, 'Phone') || validators.phone(v)}
                                    format={formatters.phone}
                                    placeholder="(222) 445-6565"
                                />
                            </div>
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-primary)', margin: '0 0 24px 0', letterSpacing: '-0.3px' }}>
                                Password Information
                            </h2>
                            <ValidatedInput
                                label="Username"
                                required
                                value={form.username}
                                onChange={(v) => updateField('username', v)}
                                validate={(v) => validators.required(v, 'Username') || validators.minLength(3)(v)}
                                placeholder="Choose a username"
                                helpText="At least 3 characters"
                            />

                            <div
                                style={{
                                    display: "flex",
                                    gap: 8,
                                    marginBottom: 16,
                                    flexWrap: "wrap"
                                }}
                            >
                                <button
                                    type="button"
                                    style={{
                                        padding: '8px 14px', borderRadius: 10,
                                        border: '1px solid rgba(124,58,237,0.3)',
                                        background: 'rgba(124,58,237,0.08)',
                                        color: '#7C3AED', fontSize: 13, fontWeight: 700,
                                        cursor: 'pointer', fontFamily: 'inherit',
                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                    }}
                                    title="Generate a strong random password"
                                    onClick={async () => {
                                        const pwd = generatePassword();

                                        updateField("password", pwd);
                                        updateField("confirmPassword", pwd);

                                        setShowPassword(true);

                                        try {
                                            await navigator.clipboard.writeText(pwd);
                                        } catch { }
                                    }}
                                >
                                    <Key size={13} strokeWidth={2.5} />
                                    Generate Password
                                </button>

                                {/*<button*/}
                                {/*    type="button"*/}
                                {/*    onClick={() => setShowPassword((s) => !s)}*/}
                                {/*>*/}
                                {/*    {showPassword ? "Hide" : "Show"}*/}
                                {/*</button>*/}

                                <button
                                    type="button"
                                    onClick={() => setShowPassword((s) => !s)}
                                    style={{
                                        padding: '8px 12px', borderRadius: 10,
                                        border: '1px solid #E8ECF0',
                                        background: '#fff',
                                        color: '#6B7280', fontSize: 13, fontWeight: 600,
                                        cursor: 'pointer', fontFamily: 'inherit',
                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                    }}
                                    title={showPassword ? 'Hide password' : 'Show password'}
                                >
                                    {showPassword
                                        ? <><EyeOff size={13} strokeWidth={2} /> Hide</>
                                        : <><Eye size={13} strokeWidth={2} /> Show</>}
                                </button>
                            </div>
                            <ValidatedInput
                                label="Password"
                                required
                                type={showPassword ? "text" : "password"}
                                value={form.password}
                                onChange={(v) => updateField('password', v)}
                                validate={(v) =>
                                    validators.required(v, 'Password') ||
                                    validators.password(v)
                                }
                                placeholder="Enter password"
                                helpText="Min 8 chars with upper, lower, and number"
                            />

                            <ValidatedInput
                                label="Confirm Password"
                                required
                                type={showPassword ? "text" : "password"}
                                value={form.confirmPassword}
                                onChange={(v) => updateField('confirmPassword', v)}
                                validate={(v) =>
                                    !v
                                        ? 'Please confirm password'
                                        : v !== form.password
                                            ? 'Passwords do not match'
                                            : null
                                }
                                placeholder="Re-enter password"
                            />

                            {/* Terms of Service & Privacy Policy Agreement */}
                            <div
                                onClick={() => { setAgreed(!agreed); if (error) setError(''); }}
                                className="termsCheck"
                                style={{
                                    display: 'flex', gap: 12, marginTop: 20, padding: '14px 16px',
                                    cursor: 'pointer', alignItems: 'flex-start',
                                    background: agreed ? 'rgba(13,148,136,0.04)' : '#F8FAFB',
                                    border: `1.5px solid ${agreed ? 'rgba(13,148,136,0.3)' : '#E8ECF0'}`,
                                    borderRadius: 12,
                                    transition: 'all 0.15s ease',
                                }}
                            >
                                <div style={{
                                    width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                                    background: agreed ? 'linear-gradient(135deg, #0D9488, #0F766E)' : 'transparent',
                                    border: `1.5px solid ${agreed ? 'transparent' : '#9CA3AF'}`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#fff', transition: 'all 0.2s',
                                    marginTop: 1,
                                }} >
                                    {agreed && <Check size={14} strokeWidth={3} />}
                                </div>
                                <span style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>
                                    I agree to the{' '}
                                    <a
                                        href="/terms"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ color: '#0D9488', fontWeight: 600, textDecoration: 'underline' }}
                                    >
                                        Terms of Service
                                    </a>
                                    {' & '}
                                    <a
                                        href="/privacy"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ color: '#0D9488', fontWeight: 600, textDecoration: 'underline' }}
                                    >
                                        Privacy Policy
                                    </a>
                                </span>
                            </div>
                        </>
                    )}

                    {/* Buttons */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 28,
                        paddingTop: 20,
                        borderTop: '1px solid var(--border-color)',
                    }}>
                        {step === 0 ? (
                            <Link to="/login" style={{ textDecoration: 'none' }}>
                                <button type="button" style={btnOutline}>
                                    &larr; Back to Login
                                </button>
                            </Link>
                        ) : (
                            <button type="button" onClick={handlePrevious} style={btnOutline}>
                                &larr; Previous
                            </button>
                        )}

                        {step < STEPS.length - 1 ? (
                            <button type="button" onClick={handleNext} style={btnPrimary}>
                                Next &rarr;
                            </button>
                        ) : (
                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{
                                    ...btnPrimary,
                                    opacity: loading ? 0.7 : 1,
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <div className="auth-footer-links">
                <a href="#terms">Terms of Service</a>
                <a href="#privacy">Privacy Policy</a>
                <a href="#contact">Contact</a>
            </div>

            {/* Cloudflare Turnstile - invisible bot protection */}
            {/*<Turnstile onVerify={setTurnstileToken} />*/}
            <Turnstile onVerify={setTurnstileToken} ref={turnstileRef} />
        </div>
    );
};

export default RegisterPage;
